export const websiteDataUpdateAction = (data) => {
    return {
        type: "WEBSITE_DATA_UPDATE",
        payload: data,
    };
};